/* Copyright (c) 2024 Xperi. All Rights Reserved.  */

import { OfferPreview as IOfferPreview } from 'client-code/previews';
import { TOfferPreview } from '../types';
import { TOfferPreviewCustomData } from '../types/TOfferPreviewCustomData';
import { PROVIDER_IMAGE_NAME, PROVIDER_IMAGE_DIMENSION } from '../strings';

export class OfferPreview implements TOfferPreview {
    networkCallId?: number | undefined;

    offerPreview: TOfferPreviewCustomData;

    constructor(data: {
        offerPreview: IOfferPreview;
        imageHostBaseUrl?: string;
        networkCallId?: number;
    }) {
        this.networkCallId = data.networkCallId;
        this.offerPreview = data.offerPreview;
        this.createProviderImageUrls(data.imageHostBaseUrl);
    }

    private createProviderImageUrls(imageHostBaseUrl?: string) {
        if (imageHostBaseUrl && this.offerPreview.contentPreview?.providersList) {
            this.offerPreview.contentPreview.providersImageUrls =
                this.offerPreview.contentPreview.providersList.map((provider) => {
                    return `${imageHostBaseUrl}/images/${provider.providerId}/${PROVIDER_IMAGE_NAME}${PROVIDER_IMAGE_DIMENSION}`;
                });
        }
    }
}
